import React from "react";
import { TypeOf } from 'zod';
import {Save} from "@mui/icons-material";
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import {Button, Stack, Box, Badge,} from "@mui/material";
import useEntity from "../../../hooks/useShipment";
import ShipmentAddForm, {formSchema, closedFormSchema} from "./ShipmentAddForm";
import { Trans } from "@lingui/react/macro";
import {ShipmentState} from "../../../types/models/ShipmentState.d";

export type FormInput = TypeOf<typeof formSchema>;

const ShipmentAddFormProvider = ({ initialFormState, cancelButton = undefined, redirectPath = undefined, successAction = undefined }) => {

    const initialData = initialFormState()

    const methods = useForm<FormInput>({
        resolver: (values, context, options) => {
            const schema = values.state === ShipmentState.Closed || values.state === ShipmentState.Finished
                ? closedFormSchema : formSchema;
            return zodResolver(schema)(values, context, options);
        },
        defaultValues: initialData
    });
    const { insertShipment, } = useEntity();

    const {
        watch,
        trigger,
        setValue,
        reset,
        handleSubmit,
        formState: { isSubmitSuccessful, errors, },
    } = methods;

    React.useEffect(() => {
        if (initialData) {
            reset(initialData);
        }
    }, [initialData, reset]);

    const watchState = watch("state")

    React.useEffect(() => {
        trigger()
    }, [watchState, trigger])

    const onSubmitHandler: SubmitHandler<FormInput> = async (values) => {
        const data = await insertShipment(values, redirectPath)
        if (data && successAction) {
            successAction(data)
        }
    };

    return (
        <>
            <FormProvider {...methods}>
                <Box
                    component='form'
                    onSubmit={
                        (e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            handleSubmit(onSubmitHandler)(e)
                        }
                    }
                    noValidate
                >

                    <ShipmentAddForm watch={watch}/>

                    <Stack direction="row" spacing={1} sx={{ justifyContent: "end", padding: 5 }}>

                        { cancelButton }

                        
                        <Badge badgeContent={Object.values(errors).length} color="error" anchorOrigin={ {vertical: 'bottom'} }>
                            <Button size="medium" variant="contained" color="primary" type='submit' startIcon={<Save />}>
                                <Trans>Add</Trans>
                            </Button>
                        </Badge>

                    </Stack>
                </Box>
            </FormProvider>
        </>
    )
}

export default ShipmentAddFormProvider;
